import { useState,useEffect } from "react";
import reload from "../../assets/icons/reload.svg";
import CustomTabsV2 from "../universal/CustomTabsV2";
import CollapsibleRightPanel from "../universal/CollapsibleRightPanel";
import { AddSermonPlansHooks } from "../../screens/SermonPlans/hooks/SermonPlansHooks";
import DropdownWithTags from "../universal/DropdownWithTags";
import LayoutDropdown from "../universal/LayoutDropdown";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import edit from "../../assets/icons/edit.svg";
import close from "../../assets/icons/close.svg";
import ReactModal from "react-modal";
import { ImCross } from "react-icons/im";
import LanguageDrawer from "../universal/LanguageDrawer";
import { useLocation } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

import { FaInfoCircle } from "react-icons/fa";
import UploadControlsV2 from "../TWG/UploadControlsV2";
import RelatedVideoInput from "../categories/RelatedVideoInput";
import VideoLibraryModal from "../TWG/VideoLibraryModal";
import { useSelector } from "react-redux";
const   AddSermonPlansFields = ({ setLoading, data ,onClose,hideUI,rowData,church}) => {
  // const { options } = GetRelatedSermonPlansHooks();

  const {
    activeTab,
    activeLanguageDetails,
    setActiveLanguageDetails,
    setActiveTab,
    handleInputChange,
    handleFileInputChange,
    handleSave,
    readLanguageData,
    sermonPlanInputs,
    setSermonPlanInputs,
    sermonPlanErrors,
    sermonPlanUrlsInputs,
    showSermonPlanLibraryModal,
    setShowSermonPlanLibraryModal,
    setSermonPlanUrlsInputs,
    setDownloadUrlsInputs,
    setTumbNailUrlsInputs,
    tumbNailUrlsInputs,
    UdownloadrlsInputs,
    handleChange,
    selectedOptions,
    setSelectedOptions,
    deleteRelatedSermonPlan,
    setSelectedRelatedSermonPlanIndex,
    handleDropdownChange,
    setLayoutValues,
    handleSermonPlanLayoutChange,
    layoutValues,
    initialLayoutValues,
    setLayoutInfo,
    layoutInfo,
    handleDateChange,
    handleAddLayoutToArray,
    layoutArray,
    setAddedLayout,
    addedLayout,
    handleSermonPlanDateChange,
    options,
    handleDeleteLayoutFromArray,
    setIsLayoutEdit,
    isLayoutEdit,
    setEditLayoutIndex,
    setEditTargetLayout,
    editTargetLayout,
    handleLayoutUpdate,
    updateStateWithTranslation,
    handleCommonTumbNailInputChange,
    setCommonUrlsInputs,
    commonSermonPlanUrlsInputs,
    previewUrlsInputs,
    setPreviewUrlsInputs,
    languagemeta,
    setIsLanguageSave,
    handleSaveLanguage,
    handleLibrarySermonPlanSelection,
    handleSendNotification,
    setLanguagemeta

  } = AddSermonPlansHooks(setLoading, data);
useEffect(() => {
  if (!rowData) return;

  // ✅ main sermonPlan inputs
  setSermonPlanInputs((prev) => ({
    ...prev,
    _id: rowData._id || prev._id,
    sermonPlan_title: rowData.sermonPlan_title || "",
    sermonPlan_description: rowData.sermonPlan_description || "",
    totalViews: rowData.sermonPlan_views || 0,
    totalLikes: rowData.totallikes || 0,
  }));

  // ✅ language metas
  setLanguagemeta(rowData?.languagemetas || []);

  // ✅ sermonPlan urls
  setSermonPlanUrlsInputs({
    mobileUploadUrl: rowData?.urls?.find((u) => u.type_of_url === "0")?.url_link || "",
    tabletUploadUrl: rowData?.urls?.find((u) => u.type_of_url === "1")?.url_link || "",
    webUploadUrl: rowData?.urls?.find((u) => u.type_of_url === "2")?.url_link || "",
  });

  // ✅ download urls
  setDownloadUrlsInputs({
    mobileUploadUrl: rowData?.downloadurls?.find((u) => u.type_of_url === "0")?.url_link || "",
    tabletUploadUrl: rowData?.downloadurls?.find((u) => u.type_of_url === "1")?.url_link || "",
    webUploadUrl: rowData?.downloadurls?.find((u) => u.type_of_url === "2")?.url_link || "",
  });

  // ✅ thumbnail urls
  setTumbNailUrlsInputs({
    mobileUploadUrl: rowData?.tumbnailurls?.find((u) => u.type_of_url === "0")?.url_link || "",
    tabletUploadUrl: rowData?.tumbnailurls?.find((u) => u.type_of_url === "1")?.url_link || "",
    webUploadUrl: rowData?.tumbnailurls?.find((u) => u.type_of_url === "2")?.url_link || "",
  });

  // ✅ generic/common thumbnails
  setCommonUrlsInputs({
    mobileUploadUrl: rowData?.gnerictumbnailurls?.find((u) => u.type_of_url === "0")?.url_link || "",
    tabletUploadUrl: rowData?.gnerictumbnailurls?.find((u) => u.type_of_url === "1")?.url_link || "",
    webUploadUrl: rowData?.gnerictumbnailurls?.find((u) => u.type_of_url === "2")?.url_link || "",
  });

  // ✅ preview trailer
  setPreviewUrlsInputs({
    mobileUploadUrl: rowData?.trailers?.find((u) => u.type_of_url === "0")?.url_link || "",
    tabletUploadUrl: rowData?.trailers?.find((u) => u.type_of_url === "1")?.url_link || "",
    webUploadUrl: rowData?.trailers?.find((u) => u.type_of_url === "2")?.url_link || "",
  });

  // ✅ related sermonPlans
  const relatedSermonPlansList =
    rowData?.relatedsermonPlans?.map((item) => ({
      value: item?.sermonPlanObjId?._id,
      label: item?.sermonPlanObjId?.sermonPlan_title,
      image: item?.sermonPlanObjId?.tumbnailurls?.[0]?.url_link || "",
    })) || [];
  setSelectedOptions(relatedSermonPlansList);
}, [rowData]);


  const [showModal, setShowModal] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");

                        const location = useLocation();

    const { userInfo } = useSelector((state) => state.user);
    const churches = useSelector((state) => state.churches.churches);
  return (
    <div className="flex flex-col md:flex-row h-full w-full flex-1 rounded-2xl overflow-hidden">
      <div className="flex h-full flex-1">

        <LanguageDrawer
          languageData={readLanguageData}
          activeTab={readLanguageData}
          setActiveTab={setActiveTab}
          setActiveLanguageDetails={setActiveLanguageDetails}
          languagemeta={languagemeta}
          setIsLanguageSave={setIsLanguageSave}
        />
        <div className="flex h-full flex-1">
          <div className="flex flex-col h-full w-full bg-greyishV2 bg-opacity-50 md:border-l md:border-r border-greyish border-opacity-30 overflow-auto">
            <div className="flex gap-4 items-center justify-between h-[64px] px-4 border-b border-[#28292a]">
              <p className="text-white font-semibold text-lg">
                {activeTab === "en"
                  ? "Add Sermon Plans"
                  : `Translate Sermon Plan to ${activeLanguageDetails?.language_name}`}
              </p>
              <div className="flex items-center gap-5">
                {activeTab !== "en" && data?._id && (
                  <p
                    className="flex items-center gap-1 text-greyish text-[11px] font-medium cursor-pointer whitespace-nowrap"
                    onClick={updateStateWithTranslation}
                  >
                    <img src={reload} alt="" /> Auto fill data with google translation
                  </p>
                )}
                {data?._id && (
                  <button
                    className="text-yellowish bg-blackish font-medium text-[12px] whitespace-nowrap border border-yellowish rounded-xl py-2 px-6"
                    onClick={handleSendNotification}
                  >
                    Send Notification
                  </button>
                )}
                {activeTab === "en" ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={() => handleSave(hideUI, onClose,church._id)}
                    >
                      {sermonPlanInputs?._id ? "Update Sermon Plan" : "Save Sermon Plan"}
                    </button>
                  </div>
                ) : data?._id ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={handleSaveLanguage}
                    >
                      Save Language
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
            {/* TAB CONTENT  */}
            {activeTab !== "en" && !data?._id ?
            (

              <div className="flex items-center justify-center text-white gap-1 py-28">
                Sermon Plan translation in{" "}
                <span className="italic">{activeLanguageDetails?.language_name}</span> is available
                for saved sermonPlans
              </div>
            ) : (

              <div className="px-4 my-4 h-full">
                <div className=" overflow-y-auto overflow-x-hidden px-2">
                  <div className="grid md:grid-cols-2 grid-cols-1 grid-rows-1 gap-x-4 gap-y-4 mx-1 w-full">
                    {userInfo?.roleCode === "17dwer8"  &&
                <div className="md:col-span-2 col-span-1 relative">
                <label className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2">
                  Select Church *
                </label>

                <div className="relative">
                  <select
                    name="churchObjId"
                    className="appearance-none bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 pr-10 focus:outline-none focus:ring-0"
                    onChange={handleChange}
                  >
                    {userInfo?.roleCode === "17dwer8" ? (
                      <>
                        <option>Select church</option>
                        <option value={userInfo?._id}>Your Church</option>
                      </>
                    ) : (
                      <>
                        <option value="">Select Church</option>
                        {churches?.data && churches.data.length > 0 ? (
                          churches.data.map((church) => (
                            <option key={church._id} value={church._id}>
                              {church.churchName}
                            </option>
                          ))
                        ) : (
                          <option disabled>No churches available</option>
                        )}
                      </>
                    )}
                  </select>

                  {/* Custom dropdown arrow */}
                  <div className="pointer-events-none absolute top-1/2 right-3 transform -translate-y-1/2 text-white">
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>

                {sermonPlanErrors?.church_id && (
                  <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
                    Church selection is required
                  </p>
                )}
              </div>

}

                    <div className="md:col-span-2 col-span-1">
                      <label
                        htmlFor="sermonPlan_title"
                        className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
                      >
                        SermonPlan Title *
                        <FaInfoCircle
                          data-tooltip-id="add_sermonPlans"
                          data-tooltip-content="Enter the SermonPlan Title"
                        />
                      </label>
                      <input
                        name="sermonPlan_title"
                        placeholder="Enter SermonPlan Title"
                        type="text"
                        className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 `}
                        // value={inputs[activeTab]?.categoryCode}
                        value={sermonPlanInputs?.sermonPlan_title}
                        onChange={handleChange}
                      />
                      {sermonPlanErrors?.sermonPlan_title && (
                        <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
                          SermonPlan Title Is Required Field
                        </p>
                      )}
                    </div>

                    <div className="md:col-span-2 col-span-1">
                      <label
                        htmlFor="sermonPlan_description"
                        className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2"
                      >
                        SermonPlan Description *
                        <FaInfoCircle
                          data-tooltip-id="add_sermonPlans"
                          data-tooltip-content="Enter the SermonPlan Description"
                        />
                      </label>
                      <textarea
                        rows={6}
                        className={`bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md`}
                        name="sermonPlan_description"
                        placeholder="Enter SermonPlan Description"
                        // value={inputs[activeTab]?.sermonPlanDescription}
                        // onChange={handleSermonPlanDescriptionChange}
                        value={sermonPlanInputs?.sermonPlan_description}
                        onChange={handleChange}
                      />
                      {sermonPlanErrors?.sermonPlan_description && (
                        <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
                          SermonPlan Description Is Required Field
                        </p>
                      )}
                    </div>
                    <UploadControlsV2
                      // showSermonPlanLibrarySelection={true}
                      // handleLibrarySermonPlanSelection={handleLibrarySermonPlanSelection}
                      tooltipTitle="Upload SermonPlan URLs"
                      className="my-2 col-span-2 mr-1"
                      title={"SermonPlan URLs " + (activeTab === "en" ? "*" : "")}
                      subtitle="Upload SermonPlan"
                      accept="sermonPlan"
                      handleChangeUrl={(event) => handleInputChange(event, setSermonPlanUrlsInputs)}
                      mobileUploadProgressId="mobileUploadUrlAddSermonPlanSermonPlanURL"
                      handleMobileFileUpload={(e) =>
                        handleFileInputChange(
                          setSermonPlanUrlsInputs,
                          "mobileUploadUrl",
                          e.target.files[0],
                          "sermonPlans",
                          "mobileUploadUrlAddSermonPlanSermonPlanURL",
                          false,
                          "sermonPlan_urls"
                        )
                      }
                      mobileUploadUrl={sermonPlanUrlsInputs?.mobileUploadUrl}
                      handleMobilePreview={() => {
                        setIsImage(false);
                        setShowModal(true);
                        setCurrentUrl(sermonPlanUrlsInputs?.mobileUploadUrl);
                      }}
                      tabletUploadProgressId="tabletUploadUrlAddSermonPlanSermonPlanURL"
                      handleTabletFileUpload={(e) =>
                        handleFileInputChange(
                          setSermonPlanUrlsInputs,
                          "tabletUploadUrl",
                          e.target.files[0],
                          "sermonPlans",
                          "tabletUploadUrlAddSermonPlanSermonPlanURL",
                          false,
                          "sermonPlan_urls"
                        )
                      }
                      tabletUploadUrl={sermonPlanUrlsInputs?.tabletUploadUrl}
                      handleTabletPreview={() => {
                        setIsImage(true);
                        setShowModal(true);
                        setCurrentUrl(sermonPlanUrlsInputs?.tabletUploadUrl);
                      }}
                      webUploadProgressId="webUploadUrlAddSermonPlanSermonPlanURL"
                      handleWebFileUpload={(e) =>
                        handleFileInputChange(
                          setSermonPlanUrlsInputs,
                          "webUploadUrl",
                          e.target.files[0],
                          "sermonPlans",
                          "webUploadUrlAddSermonPlanSermonPlanURL",
                          false,
                          "sermonPlan_urls"
                        )
                      }
                      webUploadUrl={sermonPlanUrlsInputs?.webUploadUrl}
                      handleWebPreview={() => {
                        setIsImage(true);
                        setShowModal(true);
                        setCurrentUrl(sermonPlanUrlsInputs?.webUploadUrl);
                      }}
                      isFieldRequired={sermonPlanErrors?.sermonPlan_urls}
                      requiredMessage="SermonPlan URL's Is Required"
                    />
                    <UploadControlsV2
                      tooltipTitle="Upload SermonPlan Download URLs"
                      className="my-2 col-span-2 mr-1"
                      title={"SermonPlan Download URLs " + (activeTab === "en" ? "*" : "")}
                      subtitle="Upload SermonPlan"
                      handleChangeUrl={(event) => handleInputChange(event, setDownloadUrlsInputs)}
                      mobileUploadProgressId="mobileUploadUrlAddSermonPlanSermonPlanDownloadURL"
                      handleMobileFileUpload={(e) =>
                        handleFileInputChange(
                          setDownloadUrlsInputs,
                          "mobileUploadUrl",
                          e.target.files[0],
                          "sermonPlans",
                          "mobileUploadUrlAddSermonPlanSermonPlanDownloadURL",
                          true,
                          "sermonPlan_download_urls"
                        )
                      }
                      mobileUploadUrl={UdownloadrlsInputs?.mobileUploadUrl}
                      handleMobilePreview={() => {
                        setIsImage(false);
                        setShowModal(true);
                        setCurrentUrl(UdownloadrlsInputs?.mobileUploadUrl);
                      }}
                      tabletUploadProgressId="tabletUploadUrlAddSermonPlanSermonPlanDownloadURL"
                      handleTabletFileUpload={(e) =>
                        handleFileInputChange(
                          setDownloadUrlsInputs,
                          "tabletUploadUrl",
                          e.target.files[0],
                          "sermonPlans",
                          "tabletUploadUrlAddSermonPlanSermonPlanDownloadURL",
                          true,
                          "sermonPlan_download_urls"
                        )
                      }
                      tabletUploadUrl={UdownloadrlsInputs?.tabletUploadUrl}
                      handleTabletPreview={() => {
                        setIsImage(true);
                        setShowModal(true);
                        setCurrentUrl(UdownloadrlsInputs?.tabletUploadUrl);
                      }}
                      webUploadProgressId="webUploadUrlAddSermonPlanSermonPlanDownloadURL"
                      handleWebFileUpload={(e) =>
                        handleFileInputChange(
                          setDownloadUrlsInputs,
                          "webUploadUrl",
                          e.target.files[0],
                          "sermonPlans",
                          "webUploadUrlAddSermonPlanSermonPlanDownloadURL",
                          true,
                          "sermonPlan_download_urls"
                        )
                      }
                      webUploadUrl={UdownloadrlsInputs?.webUploadUrl}
                      handleWebPreview={() => {
                        setIsImage(true);
                        setShowModal(true);
                        setCurrentUrl(UdownloadrlsInputs?.webUploadUrl);
                      }}
                      isFieldRequired={sermonPlanErrors?.sermonPlan_download_urls}
                      requiredMessage="SermonPlan Download URL's Is Required"
                      accept="sermonPlan"
                    />

                    {activeTab === "en" && (
                      <>
                        <UploadControlsV2
                          tooltipTitle="Upload SermonPlan Thumbnail"
                          className="my-2 col-span-2 mr-1"
                          title="SermonPlan Thumbnail *"
                          subtitle="Upload Image"
                          handleChangeUrl={(event) =>
                            handleInputChange(event, setTumbNailUrlsInputs)
                          }
                          mobileUploadProgressId="mobileUploadUrlAddSermonPlanSermonPlanThumbnailURL"
                          handleMobileFileUpload={(e) =>
                            handleFileInputChange(
                              setTumbNailUrlsInputs,
                              "mobileUploadUrl",
                              e.target.files[0],
                              null,
                              "mobileUploadUrlAddSermonPlanSermonPlanThumbnailURL",
                              false,
                              "sermonPlan_thumbnails_urls"
                            )
                          }
                          mobileUploadUrl={tumbNailUrlsInputs?.mobileUploadUrl}
                          handleMobilePreview={() => {
                            setIsImage(false);
                            setShowModal(true);
                            setCurrentUrl(tumbNailUrlsInputs?.mobileUploadUrl);
                          }}
                          tabletUploadProgressId="tabletUploadUrlAddSermonPlanSermonPlanThumbnailURL"
                          handleTabletFileUpload={(e) =>
                            handleFileInputChange(
                              setTumbNailUrlsInputs,
                              "tabletUploadUrl",
                              e.target.files[0],
                              null,
                              "tabletUploadUrlAddSermonPlanSermonPlanThumbnailURL",
                              false,
                              "sermonPlan_thumbnails_urls"
                            )
                          }
                          tabletUploadUrl={tumbNailUrlsInputs?.tabletUploadUrl}
                          handleTabletPreview={() => {
                            setIsImage(true);
                            setShowModal(true);
                            setCurrentUrl(tumbNailUrlsInputs?.tabletUploadUrl);
                          }}
                          webUploadProgressId="webUploadUrlAddSermonPlanSermonPlanThumbnailURL"
                          handleWebFileUpload={(e) =>
                            handleFileInputChange(
                              setTumbNailUrlsInputs,
                              "webUploadUrl",
                              e.target.files[0],
                              null,
                              "webUploadUrlAddSermonPlanSermonPlanThumbnailURL",
                              false,
                              "sermonPlan_thumbnails_urls"
                            )
                          }
                          webUploadUrl={tumbNailUrlsInputs?.webUploadUrl}
                          handleWebPreview={() => {
                            setIsImage(true);
                            setShowModal(true);
                            setCurrentUrl(tumbNailUrlsInputs?.webUploadUrl);
                          }}
                          isFieldRequired={sermonPlanErrors?.sermonPlan_thumbnails_urls}
                          requiredMessage="SermonPlan Thumbnail Is Required Field"
                        />
                        <UploadControlsV2
                          tooltipTitle="Upload Common Thumbnails"
                          className="my-2 col-span-2 mr-1"
                          title="Common Thumbnail"
                          subtitle="Upload Image"
                          handleChangeUrl={(event) => handleInputChange(event, setCommonUrlsInputs)}
                          mobileUploadProgressId="mobileUploadUrlAddSermonPlanCommonThumbnailURL"
                          handleMobileFileUpload={(e) =>
                            handleFileInputChange(
                              setCommonUrlsInputs,
                              "mobileUploadUrl",
                              e.target.files[0],
                              null,
                              "mobileUploadUrlAddSermonPlanCommonThumbnailURL",
                              false,
                              "sermonPlan_common_thumbnails_urls"
                            )
                          }
                          mobileUploadUrl={commonSermonPlanUrlsInputs?.mobileUploadUrl}
                          handleMobilePreview={() => {
                            setIsImage(false);
                            setShowModal(true);
                            setCurrentUrl(commonSermonPlanUrlsInputs?.mobileUploadUrl);
                          }}
                          tabletUploadProgressId="tabletUploadUrlAddSermonPlanCommonThumbnailURL"
                          handleTabletFileUpload={(e) =>
                            handleFileInputChange(
                              setCommonUrlsInputs,
                              "tabletUploadUrl",
                              e.target.files[0],
                              null,
                              "tabletUploadUrlAddSermonPlanCommonThumbnailURL",
                              false,
                              "sermonPlan_common_thumbnails_urls"
                            )
                          }
                          tabletUploadUrl={commonSermonPlanUrlsInputs?.tabletUploadUrl}
                          handleTabletPreview={() => {
                            setIsImage(true);
                            setShowModal(true);
                            setCurrentUrl(commonSermonPlanUrlsInputs?.tabletUploadUrl);
                          }}
                          webUploadProgressId="webUploadUrlAddSermonPlanCommonThumbnailURL"
                          handleWebFileUpload={(e) =>
                            handleFileInputChange(
                              setCommonUrlsInputs,
                              "webUploadUrl",
                              e.target.files[0],
                              null,
                              "webUploadUrlAddSermonPlanCommonThumbnailURL",
                              false,
                              "sermonPlan_common_thumbnails_urls"
                            )
                          }
                          webUploadUrl={commonSermonPlanUrlsInputs?.webUploadUrl}
                          handleWebPreview={() => {
                            setIsImage(true);
                            setShowModal(true);
                            setCurrentUrl(commonSermonPlanUrlsInputs?.webUploadUrl);
                          }}
                          isFieldRequired={sermonPlanErrors?.sermonPlan_common_thumbnails_urls}
                          requiredMessage="SermonPlan Common Thumbnail Is Required Field"
                        />
                      </>
                    )}
                    <UploadControlsV2
                      tooltipTitle="Upload Preview Trailer"
                      className="my-2 col-span-2 mr-1"
                      title="Upload Preview Trailer"
                      subtitle="Upload Preview Trailer"
                      handleChangeUrl={(event) => handleInputChange(event, setPreviewUrlsInputs)}
                      mobileUploadProgressId="mobileUploadUrlAddSermonPlanPreviewTrailerURL"
                      handleMobileFileUpload={(e) =>
                        handleFileInputChange(
                          setPreviewUrlsInputs,
                          "mobileUploadUrl",
                          e.target.files[0],
                          "sermonPlans",
                          "mobileUploadUrlAddSermonPlanPreviewTrailerURL",
                          false,
                          "sermonPlan_preview_urls"
                        )
                      }
                      mobileUploadUrl={previewUrlsInputs?.mobileUploadUrl}
                      handleMobilePreview={() => {
                        setIsImage(false);
                        setShowModal(true);
                        setCurrentUrl(previewUrlsInputs?.mobileUploadUrl);
                      }}
                      tabletUploadProgressId="tabletUploadUrlAddSermonPlanPreviewTrailerURL"
                      handleTabletFileUpload={(e) =>
                        handleFileInputChange(
                          setPreviewUrlsInputs,
                          "tabletUploadUrl",
                          e.target.files[0],
                          "sermonPlans",
                          "tabletUploadUrlAddSermonPlanPreviewTrailerURL",
                          false,
                          "sermonPlan_preview_urls"
                        )
                      }
                      tabletUploadUrl={previewUrlsInputs?.tabletUploadUrl}
                      handleTabletPreview={() => {
                        setIsImage(true);
                        setShowModal(true);
                        setCurrentUrl(previewUrlsInputs?.tabletUploadUrl);
                      }}
                      webUploadProgressId="webUploadUrlAddSermonPlanPreviewTrailerURL"
                      handleWebFileUpload={(e) =>
                        handleFileInputChange(
                          setPreviewUrlsInputs,
                          "webUploadUrl",
                          e.target.files[0],
                          "sermonPlans",
                          "webUploadUrlAddSermonPlanPreviewTrailerURL",
                          false,
                          "sermonPlan_preview_urls"
                        )
                      }
                      webUploadUrl={previewUrlsInputs?.webUploadUrl}
                      handleWebPreview={() => {
                        setIsImage(true);
                        setShowModal(true);
                        setCurrentUrl(previewUrlsInputs?.webUploadUrl);
                      }}
                      isFieldRequired={sermonPlanErrors?.sermonPlan_preview_urls}
                      requiredMessage="SermonPlan Preview Is Required Field"
                    />
                  </div>
                </div>
                {activeTab === "en" && (
                  <>
                    <RelatedVideoInput
                      categoryErrors={sermonPlanErrors}
                      setShowVideoLibraryModal={setShowSermonPlanLibraryModal}
                      handleDropdownChange={handleDropdownChange}
                      selectedOptions={selectedOptions}
                      deleteRelatedVideo={deleteRelatedSermonPlan}
                      showVideoOrder={false}
                      setSelectedOptions={setSelectedOptions}
                      setSelectedRelatedVideoIndex={setSelectedRelatedSermonPlanIndex}
                      isFieldRequired={false}
                      videoLabelClassName={"col-span-2"}
                    />
                    <VideoLibraryModal
                      showVideoLibraryModal={showSermonPlanLibraryModal}
                      setShowVideoLibraryModal={setShowSermonPlanLibraryModal}
                      handleVideoSelection={handleDropdownChange}
                    />
                  </>
                )}
              </div>
            )}
            <Tooltip id="add_sermonPlans" className="border border-greyish border-opacity-20" />
          </div>
        </div>
      </div>
      <CollapsibleRightPanel title="Stats / Layouts">
        <CustomTabsV2
          tabHeight={"h-[64px]"}
          tabsTitleArray={["Stats", "Layouts"]}
          tabsContentObject={{
            Stats: (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                {data?._id ? (
                  <div className="w-full px-8">
                    <p>
                      Views : <strong>{sermonPlanInputs?.totalViews}</strong>
                    </p>
                    <p>
                      Likes: <strong>{sermonPlanInputs?.totalLikes}</strong>
                    </p>
                  </div>
                ) : (
                  <>No stats available for sermonPlan</>
                )}
              </div>
            ),
            Layouts: !data?._id ? (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                Save this sermonPlan to assign the layout
              </div>
            ) : (
              <>
                <div className="mt-4 p-1">
                  <label htmlFor="relatedSermonPlans" className="text-[12px] text-greyish font-medium">
                    Layouts
                  </label>
                  <div className="bg-blackish py-4 px-3 mt-3 rounded-lg">
                    <LayoutDropdown
                      setMyState={setLayoutValues}
                      setLayoutInfo={setLayoutInfo}
                      setAddedLayout={setAddedLayout}
                      addedLayout={addedLayout}
                      newTarget={editTargetLayout}
                      isLayoutEdit={isLayoutEdit}
                      outerTargetLayout={layoutValues?.layout_name}
                    />

                    {layoutInfo && (
                      <>
                        {/* <div className="flex gap-3">
                          <div className="w-full">
                            <label
                              htmlFor="title"
                              className="text-[12px] text-greyish font-medium leading-4 "
                            >
                              Layout Title
                            </label>
                            <input
                              type="text"
                              className={`bg-greyishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10`}
                              name="title"
                              placeholder="Enter title"
                              value={layoutValues?.title}
                              onChange={handleSermonPlanLayoutChange}
                            />
                          </div>
                          <div className="w-full">
                            <label
                              htmlFor="subtitle"
                              className="text-[12px] text-greyish font-medium leading-4 "
                            >
                              Layout Subtitle
                            </label>
                            <input
                              type="text"
                              className={`bg-greyishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10`}
                              name="subtitle"
                              placeholder="Enter subtitle "
                              value={layoutValues?.subtitle}
                              onChange={handleSermonPlanLayoutChange}
                            />
                          </div>
                        </div> */}
                        <div className="flex gap-3">
                          {/* <div className="w-full flex flex-col mt-2">
                            <label
                              htmlFor="expiry"
                              className="text-[12px] text-greyish font-medium leading-4"
                            >
                              Expiry
                            </label>
                            <DateTimePicker
                              name="expiry"
                              className={
                                "bg-greyishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
                              }
                              value={layoutValues?.expiry}
                              onChange={handleSermonPlanDateChange}
                            />
                          </div> */}
                          <div className="w-full">
                            <label
                              htmlFor="order"
                              className="text-[12px] text-greyish font-medium leading-4 "
                            >
                              Display Order
                            </label>
                            <input
                              type="text"
                              className={`bg-greyishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10`}
                              name="order"
                              placeholder="Enter order"
                              value={layoutValues?.order}
                              onChange={handleSermonPlanLayoutChange}
                            />
                          </div>
                        </div>
                        <div className="flex justify-end mt-4">
                          <div className="flex gap-3">
                            {!isLayoutEdit && (
                              <button
                                className="text-greyish bg-blackishV2 font-medium text-[12px] rounded-xl py-2 px-6"
                                onClick={() => {
                                  setLayoutValues(initialLayoutValues);
                                  setLayoutInfo(false);
                                }}
                              >
                                Cancel
                              </button>
                            )}
                            {isLayoutEdit ? (
                              <button
                                className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                                onClick={handleLayoutUpdate}
                              >
                                Confirm
                              </button>
                            ) : (
                              <button
                                className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                                onClick={handleAddLayoutToArray}
                              >
                                Add
                              </button>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {layoutArray?.length > 0 &&
                  activeTab === "en" &&
                  layoutArray?.map((item, index) => (
                    <div className="w-full px-4 mt-4">
                      <div className="w-full p-2 px-4 bg-black bg-opacity-10 rounded-lg border border-opacity-25 border-white">
                        <div className="flex flex-col items-center justify-center w-full text-white">
                          <div className="flex justify-between w-full">
                            <p className="text-sm font-white font-medium text-white">
                              {item?.layout_name}
                            </p>
                            <div className="flex gap-2 justify-end items-center cursor-pointer">
                              <img
                                className="h-4"
                                src={edit}
                                alt=""
                                onClick={() => {
                                  setIsLayoutEdit(true);
                                  setEditLayoutIndex(index);
                                  setLayoutValues(item);
                                  setEditTargetLayout(item?.layout_name);
                                }}
                              />
                              <img
                                className="h-4"
                                src={close}
                                alt=""
                                onClick={() => {
                                  handleDeleteLayoutFromArray(item?._id);
                                }}
                              />
                            </div>
                          </div>
                          <div className="flex justify-between w-full mt-5 bg-blackishV2 p-1 px-2">
                            <p className="text-[10px] font-white text-white">Order</p>
                            {/* <p className="text-[10px] font-white text-white">Title</p>
                            <p className="text-[10px] font-white  text-white">Subtitle</p>
                            <p className="text-[10px] font-white text-white">Expiry</p> */}
                          </div>
                          <div className="flex w-full mt-2 p-1 px-2">
                            <p className="flex w-full text-xs font-white font-bold text-white">
                              {item?.order}
                            </p>
                            {/* <p className="flex w-full  text-xs font-white font-bold text-white">
                              {item?.title}
                            </p>
                            <p className="flex w-full justify-center text-xs font-white font-bold text-white">
                              {item?.subtitle}
                            </p>
                            <p className="flex w-full justify-end text-end  text-xs font-white font-bold text-white">
                              {moment(item?.expiry).format("DD-MM-YYYY")}
                            </p> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            ),
          }}
        />
      </CollapsibleRightPanel>
      <ReactModal isOpen={showModal} onRequestClose={() => setShowModal(false)}>
        <div className="flex justify-center h-full w-full relative">
          <div
            className="absolute top-0 right-0 cursor-pointer"
            onClick={() => setShowModal(false)}
          >
            <ImCross />
          </div>
          {isImage ? (
            <img className="h-full" src={currentUrl} />
          ) : (
            <video className="h-full" controls autoPlay>
              <source src={currentUrl} />
            </video>
          )}
        </div>
      </ReactModal>
    </div>
  );
};

export default AddSermonPlansFields;
